import React from "react";
import Dashboard from "../components/Dashboard/Dashboard";
import { MainDiv } from "../components/Profile/Profile.style";

const DashboardPage = () => {
  return (
    <MainDiv
      style={{
        height: "calc(100vh - 70px)",
      }}
    >
      <Dashboard></Dashboard>
    </MainDiv>
  );
};

export default DashboardPage;
